import Vue from 'vue';
import Anim from '@/components/elements/anim';
//import GroupTopicsDraggable from "@/components/context/context-topics-draggable";
import DialogDelete from "@/components/dialogs/dialog-delete";
import Loader from "@/components/elements/loader";
import Avatar from "@/components/elements/avatar";
import Logo from "@/components/elements/logo";
import ContextListItem from "@/components/context/context-list-item";
import ContextTasks from "@/components/context/context-tasks";
import ContextTask from "@/components/context/context-task";
import ContextTopic from "@/components/context/context-topic";
import Tag from "@/components/tags/tag";

// default tags
//import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
Vue.component('anim', Anim);
//Vue.component('group-topics-draggable', GroupTopicsDraggable);
Vue.component('dialog-delete', DialogDelete);
Vue.component('loader', Loader);
Vue.component('avatar', Avatar);
Vue.component('logo', Logo);
Vue.component('context-list-item', ContextListItem);
Vue.component('context-tasks', ContextTasks);
Vue.component('context-task', ContextTask);
Vue.component('context-topic', ContextTopic);
Vue.component('tag', Tag);
